import { BrowserHistoryWithEntries } from 'browser-history-with-entries';

export const history = BrowserHistoryWithEntries();
